module.exports = __webpack_public_path__ + "static/l1-723743af116e0818be8c26fc4cd3a2ee.png";